// extracted by mini-css-extract-plugin
export default {"navElement":"navElement_navElement__EtwAH","text":"navElement_text__W4SEA","icon":"navElement_icon__lYcnf"};